import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceLineMetric, ServiceLineMetricQuery } from '@shared/models/service-line-metric.model';
import { HttpContext, HttpHeaders } from '@angular/common/http';
import { EvaluateData } from '@shared/models/service-line-routing.model';
import { MetricsBaseService } from '@core/services/metrics/metrics-base.service';
import { API_CONTEXT_TOKEN } from '@core/constants';

@Injectable({
  providedIn: 'root',
})
export class ServiceLineMetricsService extends MetricsBaseService {
  uniqueKey = 'serviceLineMetricId';

  query(query: string): Observable<ServiceLineMetricQuery> {
    const context = new HttpContext();
    context.set(API_CONTEXT_TOKEN, 'metrics');

    return this.http.post<ServiceLineMetricQuery>(
      `${this.API_URL}/${this.productName.value}/serviceLineMetrics/$query`,
      `"${query}"`,
      {
        headers: new HttpHeaders({ 'content-type': 'application/json' }),
        context,
      }
    );
  }

  getEvaluateQueue(metric: ServiceLineMetric): Observable<EvaluateData> {
    return this.http.get<EvaluateData>(
      `${this.API_URL}/${this.productName.value}/serviceLineMetrics/${metric.serviceLineMetricId}/requirements`
    );
  }
}
